module.exports = __webpack_public_path__ + "static/media/shoppingBug.3394f2f7.svg";